import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

// Chakra imports
import { Box, Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import BarChart from "components/charts/BarChart";

// Custom components
import Card from "components/card/Card.js";
import {
  barChartDataDailyTraffic,
  barChartOptionsDailyTraffic,
} from "variables/charts";

// Assets
import { RiArrowUpSFill } from "react-icons/ri";

// Constants
import constants from "providers/Constants";

export default function DailyTraffic(props) {
  const { data, ...rest } = props;
  const { t } = useTranslation();

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");

  useEffect(() => {
    calculateTotalSpentPercentage(data)
  }, [data]);

  return (
    <Card align='center' direction='column' w='100%' {...rest}>
      <Flex justify='space-between' align='start' px='10px' pt='5px'>
        <Flex flexDirection='column' align='start' me='20px'>
          <Flex w='100%'>
            <Text
              me='auto'
              color='secondaryGray.600'
              fontSize='sm'
              fontWeight='500'>
              {t("Weekly Spend")}
            </Text>
          </Flex>
          <Flex align='end'>
            <Text
              color={textColor}
              fontSize='34px'
              fontWeight='700'
              lineHeight='100%'>
             {calculateTotalSpentPercentage(data)?.amount}
            </Text>
            <Text
              ms='6px'
              color='secondaryGray.600'
              fontSize='sm'
              fontWeight='500'>
              {calculateTotalSpentPercentage(data)?.currency}
            </Text>
          </Flex>
        </Flex>
        <Flex align='center'>
          <Icon as={RiArrowUpSFill} color='green.500' />
          <Text color='green.500' fontSize='sm' fontWeight='700'>
            {calculateTotalSpentPercentage(data)?.percentage}
          </Text>
        </Flex>
      </Flex>
      <Box h='240px' mt='auto'>
        <BarChart
          chartData={transformChartDataYearly(data)}
          chartOptions={barChartOptionsDailyTraffic}
        />
      </Box>
    </Card>
  );

  // Calculate total spent percentage
  function calculateTotalSpentPercentage(data) {
    const currentWeek = new Date().toLocaleString('default', { weekday: 'short' }).toLowerCase();
    const totalSpent = Object.keys(data)
      .filter(key => key !== 'currency')
      .reduce((sum, key) => sum + Number(data[key]), 0);
    const currentWeekSpent = Number(data[currentWeek] || 0);
    const percentage = ((currentWeekSpent / totalSpent) * 100).toFixed(2);
    return {
      currency: data?.currency,
      amount: currentWeekSpent.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      percentage: `${percentage}%`
    };
  }

  // Transform chart data (weekly)
  function transformChartDataYearly(input) {
    const daysOrder = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    const weeklyData = daysOrder.map(day => Number(input[day] || 0));
    return [
        {
          name: t("Weekly Spend"),
          data: weeklyData,
        },
    ];
  }

}
